export default __webpack_public_path__ + "static/media/arrow-back.5a42799e.svg";